export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14676.96b2024a.jpg";